import { Translate } from '../../../shared/LanguageService';
import { CustomersFallingBack } from '../types';

function customerList(customersFallingBack: CustomersFallingBack): string {
    const names = customersFallingBack.customers.join(', ');

    if (customersFallingBack.remainingCustomerCount === 0) {
        return names;
    }

    return `${names} ${Translate('customer-agreements/form/error/in-use-remaining-customers', {
        count: customersFallingBack.remainingCustomerCount
    })}`;
}

export function customersFallingBackText(customersFallingBack: CustomersFallingBack): string {
    return Translate('customer-agreements/notification/deactivated-customers-fall-back', {
        customers: customerList(customersFallingBack)
    });
}
